import { AuthConfiguration } from '../../models';

export abstract class AbstractAuthConfigService {
    abstract getConfig(): AuthConfiguration;
}
